import connectTo from './Container';
import PrivateRoute from './PrivateRoute';

export default connectTo(PrivateRoute);
